export default __webpack_public_path__ + "static/media/bae448a323457bcc80152b07fcf9f828.57e8c3b4.png";